"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var _ = require("lodash");
var react_hook_form_1 = require("react-hook-form");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var modal_1 = require("../../components/common/modal");
var form_element_hook_1 = require("../../components/form/form-element-hook");
var validation_1 = require("../../core/validation");
var INVITE_STAFF = require("../../core/gql/mutations/invite-staff");
var SetFeedbackMessage = require("../../core/gql/mutations/set-feedback-message");
var role_1 = require("../../models/role");
var show_staff_1 = require("../../core/gql/queries/show-staff");
var CreateElement = form_element_hook_1.default;
var InviteStaff = function (_a) {
    var orgId = _a.orgId, onClose = _a.onClose, isOpen = _a.isOpen;
    var inviteStaffForm = react_hook_form_1.useForm();
    var _b = react_apollo_1.useMutation(INVITE_STAFF.MUTATION, {
        refetchQueries: [{ query: show_staff_1.QUERY, variables: { organizationId: orgId } }],
    }), inviteStaff = _b[0], inviteStaffResponse = _b[1];
    var setFeedbackMessage = react_apollo_1.useMutation(SetFeedbackMessage.MUTATION)[0];
    var handleSubmit = inviteStaffForm.handleSubmit, register = inviteStaffForm.register;
    var hide = function (updated) {
        return onClose();
    };
    var submit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, inviteStaff({
                        variables: {
                            firstName: values.firstName,
                            lastName: values.lastName,
                            email: values.email,
                            orgId: orgId,
                            role: role_1.RoleType.ADMIN,
                        },
                    })];
                case 1:
                    resp = _a.sent();
                    if (_.get(resp, "data.inviteUser.id")) {
                        hide(true);
                        setFeedbackMessage({
                            variables: {
                                message: "Your invitation is on it's way!",
                                isError: false,
                                autoclose: true,
                            },
                        });
                    }
                    else {
                        setFeedbackMessage({
                            variables: {
                                message: "Oops!  We dropped the ball. Please send your invitation again.",
                                isError: false,
                                autoclose: true,
                            },
                        });
                        console.error("Unable to invite new user to organization.");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var isSubmitting = inviteStaffResponse.loading;
    return (React.createElement(modal_1.default, { isOpen: isOpen, onClose: onClose },
        React.createElement("div", null,
            React.createElement(teamsnap_ui_1.Panel, { mods: "Panel--form" },
                React.createElement(teamsnap_ui_1.PanelHeader, { title: "Invite Staff" }),
                React.createElement(teamsnap_ui_1.PanelBody, null,
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size12of12" },
                            React.createElement(teamsnap_ui_1.Grid, { isWithGutter: true },
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                                    React.createElement(CreateElement, { useHookResponse: inviteStaffForm, inputRef: register({
                                            required: "You must provide the staff member's first name.",
                                        }), field: "firstName", type: "text", placeholder: "First Name", label: "First Name" })),
                                React.createElement(teamsnap_ui_1.Cell, { mods: "u-size6of12" },
                                    React.createElement(CreateElement, { useHookResponse: inviteStaffForm, inputRef: register({
                                            required: "You must provide the staff member's last name.",
                                        }), field: "lastName", type: "text", placeholder: "Last Name", label: "Last Name" }))))),
                    React.createElement(teamsnap_ui_1.PanelRow, { isWithCells: true, mods: "Panel-row--header" },
                        React.createElement(teamsnap_ui_1.PanelCell, { mods: "u-size12of12" },
                            React.createElement(CreateElement, { useHookResponse: inviteStaffForm, inputRef: register({
                                    required: "You must enter an email address to send the invitation.",
                                    validate: function (value) { return validation_1.validEmail(value) || "You must enter an email address to send the invitation."; },
                                }), type: "email", field: "email", placeholder: "Staff Email", label: "Staff Email" })))),
                React.createElement(teamsnap_ui_1.PanelFooter, null,
                    React.createElement("form", { onSubmit: handleSubmit(submit) },
                        React.createElement("div", { className: "button-list" },
                            React.createElement(teamsnap_ui_1.Button, { mods: "Button--negative", icon: "dismiss", onClick: hide }, "Cancel"),
                            React.createElement(teamsnap_ui_1.Button, { isDisabled: isSubmitting, color: "primary", icon: isSubmitting ? null : "check", type: "submit" },
                                isSubmitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: "13px", height: "13px" } }),
                                "Invite Staff Member"))))))));
};
exports.default = InviteStaff;
//# sourceMappingURL=invite-staff.js.map